import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import RCAUserWithAvatar from "pages/Corporate/RCA/components/RCAUserWithAvatar";
import { useStyles } from "./useRCAIssuesActionPlansColumns.styles";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { translateDefaultEntity } from "utilities/localesUtilities";
import useDateFormat from "hooks/useDateFormat";

interface IRCAIssuesActionPlansColumns extends Omit<IMainTableColumn, "render"> {
    render: (row: IActionPlan) => string | JSX.Element | number;
}

const useRCAIssuesActionPlansColumns = (): IRCAIssuesActionPlansColumns[] => {
    const { t, i18n } = useTranslation();
    const { formatDate } = useDateFormat();
    const classes = useStyles();
    const columns = useMemo(
        (): IRCAIssuesActionPlansColumns[] => [
            {
                id: "description",
                label: "",
                hideSortIcon: true,
                customStyles: { width: "65%" },
                render: (row) => (
                    <div className={classes.descriptionWrapper}>
                        <div className={classes.descriptionTicketNumber}>{`AP${row.action_plan_id}`}</div>
                        <div className={classes.description}>{row.description}</div>
                    </div>
                ),
            },
            {
                id: "status",
                label: t("rca.issues.issue_detail.action_plans.status"),
                hideSortIcon: true,
                customStyles: { width: "15%" },
                render: (row) =>
                    translateDefaultEntity(i18n.language, row.status, "name", DefaultTranslationFieldsInTable.STATUS),
            },
            {
                id: "dueDate",
                label: t("rca.issues.issue_detail.action_plans.due_date"),
                hideSortIcon: true,
                align: "center",
                customStyles: { width: "15%" },
                render: (row) => formatDate(row.due_date),
            },
            {
                id: "owner",
                label: "",
                hideSortIcon: true,
                align: "center",
                customStyles: { width: "5%" },
                render: (row) => (
                    <RCAUserWithAvatar
                        imageUrl={row.assignee?.media?.media_url || ""}
                        name={`${row.assignee?.first_name} ${row.assignee?.last_name}`}
                        hideText
                    />
                ),
            },
        ],
        [classes.description, classes.descriptionTicketNumber, classes.descriptionWrapper, i18n.language, t, formatDate],
    );

    return columns;
};

export default useRCAIssuesActionPlansColumns;
